import React, { useState } from "react";
import { Button, Typography } from "antd";

import { ModulePicker } from "../../components";
import { DEFAULT_MODULES } from "../../constants/modules";
import styles from "./styles.module.css";

/* Second step of setup: which optional sections this workspace wants.
 *
 * It comes before the project step on purpose — it decides what the sidebar
 * looks like the first time it is seen, and it is the one question in the
 * wizard with no wrong answer, so it is a gentle way in. Nothing here is
 * final: every one of these is a switch in فضای کاری › ماژول‌ها, which is what
 * the hint under the list says.
 *
 * The choice is stored against the organization's uuid on the panel side, not
 * sent to the API — turning a section off hides it, it does not take anything
 * away. */
const ModulesStep = ({ loading, onSubmit, onSkip }) => {
  const [modules, setModules] = useState(DEFAULT_MODULES);

  return (
    <>
      <div className={styles.stepHead}>
        <Typography.Title level={4} className={styles.stepTitle}>
          کدوم بخش‌ها رو لازم داری؟
        </Typography.Title>
        <p className={styles.stepDescription}>
          تسک‌ها، پروژه‌ها، گزارش‌ها و تقویم همیشه هستن.
          — هر کدوم رو خاموش بذاری از منو برداشته می‌شه و هر وقت
          خواستی برمی‌گرده.
        </p>
      </div>

      <ModulePicker value={modules} onChange={setModules} />

      <div className={styles.stepActions}>
        <Button
          type="primary"
          size="large"
          block
          loading={loading}
          onClick={() => onSubmit(modules)}
        >
          ادامه
        </Button>
        <Button
          type="text"
          disabled={loading}
          className={styles.skipButton}
          onClick={() => onSkip(DEFAULT_MODULES)}
        >
          فرقی نمی‌کنه، همه‌شون باشن
        </Button>
      </div>
    </>
  );
};

export default ModulesStep;
